export default ({ request }) => ({
  ecomPlatformListApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/list',
      method: 'POST',
      data,
    })
  },
  ecomPlatformDetailApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/detail',
      method: 'POST',
      data,
    })
  },
  ecomPlatformSaveApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/save',
      method: 'POST',
      data,
    })
  },
})
